import React from 'react'
import { Card, Container, Tab, Tabs } from 'react-bootstrap';
import AllEnrollmentsTable from './AllTable';
import PaidEnrollmentsTable from './PaidTable';

export default function AllEnrollmentsIndex() {

    return (
        <>
            <Container className="pt-4">
                <Card className="mt-4">
                    <Card.Title className='m-2'>Enrollments</Card.Title>
                    <Card.Body>

                        <Tabs
                            defaultActiveKey="all"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                        >
                            <Tab
                                eventKey="all"
                                title={
                                    <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>All</div>
                                }
                            >
                                <AllEnrollmentsTable />
                            </Tab>
                            <Tab
                                eventKey="paid"
                                title={
                                    <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                                        Paid
                                    </div>
                                }
                            >
                                <PaidEnrollmentsTable />
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
};